import { useStore } from '@/utils/vue-api';
import { computed, getCurrentInstance } from 'vue';

export const useCustomCore = () => {
	const store = useStore();
	const allModules = computed(() => store.getters.getIrTemplateFlattenModules || []);
	const findModule = moduleId => {
		const findModule = allModules.value.find(module => module.moduleId === moduleId);
		return findModule || {};
	};

	const vm = getCurrentInstance();
	const getRealModuleId = moduleId => {
		if (moduleId) return moduleId;
		const moduleIdInQuery = vm.proxy.$route.query.moduleId;
		const moduleIdInParams = vm.proxy.$route.params.moduleId;
		return moduleIdInQuery || moduleIdInParams;
	};

	return {
		findModule,
		getRealModuleId
	};
};
